import axios from 'axios';
import { getEnv } from '../envConfig'
import authTokenStore from './authTokenStore';

const API_URL = getEnv().ENDPOINT;

function mapTokenResponse(response) {
  const tokenPayload = response?.data?.data || response?.data || {};
  const accessToken = tokenPayload.access_token || null;

  authTokenStore.setAccessToken(accessToken);

  return {
    accessToken,
    response,
  };
}

export async function login({ username, password }) {
  const response = await axios.post(
    `${API_URL}/api/v1/auth/token`,
    { username, password },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const { accessToken } = mapTokenResponse(response);

  return {
    data: {
      access_token: accessToken,
    },
  };
}

export function getAccessToken() {
  return authTokenStore.getAccessToken();
}

export function setAccessToken(token) {
  authTokenStore.setAccessToken(token);
}

export async function refreshToken() {
  const response = await axios.post(
    `${API_URL}/api/v1/auth/refresh`,
    {},
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const { accessToken } = mapTokenResponse(response);
  return accessToken;
}

export async function logout() {
  try {
    await axios.post(
      `${API_URL}/api/v1/auth/logout`,
      {},
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  } finally {
    authTokenStore.clearAccessToken();
  }
}

export function clearAccessToken() {
  authTokenStore.clearAccessToken();
}
